// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var userRouter = {
  path: '/user',
  component: Layout,
  redirect: '/user/index',
  name: 'User',
  meta: {
    title: '用户',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/user/list/index');
    },
    name: 'UserIndex',
    meta: {
      title: '用户列表',
      icon: ''
    }
  }, {
    path: 'wallet/restrictedUserWallet',
    component: function component() {
      return import('@/views/user/wallet/restrictedUserWallet/index');
    },
    name: 'UserRestrictedUserWallet',
    meta: {
      title: '积分受限用户',
      icon: ''
    }
  }, {
    path: 'activeIndex',
    component: function component() {
      return import('@/views/user/list/activeIndex');
    },
    name: 'UserActiveIndex',
    meta: {
      title: '用户活跃列表',
      icon: ''
    }
  }, {
    path: 'boleIndex',
    component: function component() {
      return import('@/views/user/list/boleIndex');
    },
    name: 'UserBoleIndex',
    meta: {
      title: '用户伯乐列表',
      icon: ''
    }
  }, {
    path: 'discount',
    component: function component() {
      return import('@/views/user/discount/index');
    },
    name: 'UserDiscount',
    meta: {
      title: '折扣配置',
      icon: ''
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/user/level');
    },
    name: 'Level',
    meta: {
      title: '用户等级',
      icon: ''
    },
    children: [{
      path: 'list',
      name: 'levelList',
      meta: {
        title: '等级列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/level/list');
      }
    }, {
      path: 'config',
      name: 'levelConfig',
      meta: {
        title: '等级配置',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/level/levelConfig');
      }
    }, {
      path: 'description',
      name: 'levelDescription',
      meta: {
        title: '等级说明',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/level/description');
      }
    }
    // {
    //   path: 'description',
    //   name: 'levelDescription',
    //   meta: {
    //     title: '等级说明',
    //     noCache: true,
    //   },
    //   component: () => import('@/views/user/level/description'),
    // },
    ]
  }, {
    path: 'label',
    component: function component() {
      return import('@/views/user/label/index');
    },
    name: 'Label',
    meta: {
      title: '用户标签',
      icon: ''
    }
  }, {
    path: 'team',
    component: function component() {
      return import('@/views/user/team');
    },
    name: 'Team',
    meta: {
      title: '团队管理',
      icon: ''
    },
    children: [{
      path: 'agentteam',
      component: function component() {
        return import('@/views/user/team/agentTeam/index');
      },
      name: 'agentTeam',
      meta: {
        title: '团队领导',
        icon: ''
      }
    }, {
      path: 'agentuserteam',
      component: function component() {
        return import('@/views/user/team/agentUserTeam/index');
      },
      name: 'agentUserTeam',
      meta: {
        title: '团队用户',
        icon: ''
      }
    }, {
      path: 'agentProjectTeam',
      component: function component() {
        return import('@/views/user/team/agentProjectTeam/index');
      },
      name: 'agentProjectTeam',
      meta: {
        title: '团队项目',
        icon: ''
      }
    }]
  }, {
    path: 'capa',
    component: function component() {
      return import('@/views/user/capa');
    },
    name: 'Capa',
    meta: {
      title: '会员配置',
      icon: ''
    },
    children: [{
      path: 'agentusercapa',
      name: 'agentUserCapa',
      meta: {
        title: '用户等级'
      },
      component: function component() {
        return import('@/views/user/capa/agentUserCapa/index');
      }
    }, {
      path: 'agentusersnapshotcapa',
      name: 'agentUserSnapshotCapa',
      meta: {
        title: '用户等级快照'
      },
      component: function component() {
        return import('@/views/user/capa/agentUserSnapshotCapa/index');
      }
    },
    // {
    //   path: 'config',
    //   name: 'levelConfig',
    //   meta: {
    //     title: '用户星级',
    //   },
    //   component: () => import('@/views/user/level/levelConfig'),
    // },
    // {
    //   path: 'description',
    //   name: 'levelDescription',
    //   meta: {
    //     title: '用户星级快照',
    //   },
    //   component: () => import('@/views/user/level/description'),
    // },
    {
      path: 'agentcapa',
      name: 'agentCapa',
      meta: {
        title: '等级管理'
      },
      component: function component() {
        return import('@/views/user/capa/agentCapa/index');
      }
    }, {
      path: 'gradecondition/:id/',
      name: 'gradecondition',
      meta: {
        title: '等级升级条件'
      },
      component: function component() {
        return import('@/views/user/capa/agentCapa/gradecondition');
      }
    }, {
      path: 'condition/:id/',
      component: function component() {
        return import('@/views/user/capa/agentCapaXs/condition');
      },
      name: 'condition',
      meta: {
        title: '星级升级条件',
        icon: ''
      }
    }, {
      path: 'agentcapaxs',
      name: 'agentCapaXs',
      meta: {
        title: '星级管理'
      },
      hidden: true,
      component: function component() {
        return import('@/views/user/capa/agentCapaXs/index');
      }
    }, {
      path: 'agentusercapaxs',
      name: 'agentUserCapaXs',
      meta: {
        title: '用户星级'
      },
      component: function component() {
        return import('@/views/user/capa/agentUserCapaXs/index');
      }
    }, {
      path: 'agentuserxssnapshotcapa',
      name: 'agentUserxsSnapshotCapa',
      meta: {
        title: '用户星级快照'
      },
      component: function component() {
        return import('@/views/user/capa/agentUserXsSnapshotCapa/index');
      }
    }]
  }, {
    path: 'region',
    component: function component() {
      return import('@/views/user/region');
    },
    name: 'Region',
    meta: {
      title: '区域管理',
      icon: ''
    },
    children: [{
      path: 'userregion',
      component: function component() {
        return import('@/views/user/region/userRegion/index');
      },
      name: 'userRegion',
      meta: {
        title: '用户区域',
        icon: ''
      }
    }, {
      path: 'companyregion',
      component: function component() {
        return import('@/views/user/region/companyRegion/index');
      },
      name: 'companyRegion',
      meta: {
        title: '公司区域',
        icon: ''
      }
    }, {
      path: 'usersubsidy',
      component: function component() {
        return import('@/views/user/region/userSubsidy/index');
      },
      name: 'usersubsidy',
      meta: {
        title: '线下补助',
        icon: ''
      }
    }]
  }, {
    path: 'white',
    component: function component() {
      return import('@/views/user/white');
    },
    name: 'White',
    meta: {
      title: '白名单配置',
      icon: ''
    },
    children: [{
      path: 'whiteuser',
      name: 'whiteUser',
      meta: {
        title: '用户白名单',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/white/whiteUser/index');
      }
    }, {
      path: 'whiteregulate',
      name: 'whiteRegulate',
      meta: {
        title: '白名单管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/user/white/whiteRegulate/index');
      }
    }]
  }, {
    path: 'userrelation',
    component: function component() {
      return import('@/views/user/userrelation');
    },
    name: 'userRelation',
    meta: {
      title: '用户关系',
      noCache: true
    },
    children: [{
      path: 'relation',
      name: 'Relation',
      meta: {
        title: '服务关系'
      },
      component: function component() {
        return import('@/views/user/userrelation/relation');
      },
      children: [{
        path: 'relationcompete',
        name: 'relationCompete',
        meta: {
          title: '上级关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/relation/relationcompete');
        }
      }, {
        path: 'relationflow',
        name: 'relationFlow',
        meta: {
          title: '层级关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/relation/relationflow');
        }
      }, {
        path: 'relationtree',
        name: 'relationTree',
        meta: {
          title: '关系树',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/relation/relationtree');
        }
      }]
    }, {
      path: 'invitation',
      name: 'Invitation',
      meta: {
        title: '销售关系'
      },
      component: function component() {
        return import('@/views/user/userrelation/invitation');
      },
      children: [{
        path: 'invitationcompete',
        name: 'invitationCompete',
        meta: {
          title: '上级关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/invitation/invitationcompete');
        }
      }, {
        path: 'invitationflow',
        name: 'invitationFlow',
        meta: {
          title: '层级关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/invitation/invitationflow');
        }
      }, {
        path: 'invitationtree',
        name: 'invitationTree',
        meta: {
          title: '关系树',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/invitation/invitationtree');
        }
      }, {
        path: 'invitationskip',
        name: 'invitationskip',
        meta: {
          title: '跳转关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/invitation/invitationskip');
        }
      }]
    }, {
      path: 'seeorder',
      name: 'Seeorder',
      meta: {
        title: '见单关系'
      },
      component: function component() {
        return import('@/views/user/userrelation/seeorder');
      },
      children: [{
        path: 'seeordercompete',
        name: 'seeorderCompete',
        meta: {
          title: '上级关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/seeorder/seeordercompete');
        }
      }, {
        path: 'seeorderflow',
        name: 'seeorderFlow',
        meta: {
          title: '层级关系',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/seeorder/seeorderflow');
        }
      }, {
        path: 'seeordertree',
        name: 'seeorderTree',
        meta: {
          title: '关系树',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/seeorder/seeordertree');
        }
      }]
    }, {
      path: 'relational',
      name: 'relational',
      meta: {
        title: '关系拓扑图'
      },
      component: function component() {
        return import('@/views/user/userrelation/relational');
      },
      children: [{
        path: 'placement',
        name: 'placement',
        meta: {
          title: '服务关系图',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/relational/placement');
        }
      }, {
        path: 'market',
        name: 'market',
        meta: {
          title: '销售关系图',
          noCache: true
        },
        component: function component() {
          return import('@/views/user/userrelation/relational/market');
        }
      }]
    }]
  }, {
    path: 'identity',
    component: function component() {
      return import('@/views/user/identity/index');
    },
    name: 'userIdentity',
    meta: {
      title: '实名认证',
      icon: ''
    }
  }, {
    path: 'Jwebmalladmin',
    component: function component() {
      return import('@/views/user/Jwebmalladmin');
    },
    name: 'Jwebmalladmin',
    meta: {
      title: '共享仓',
      icon: ''
    },
    children: [{
      path: 'store',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/store/index');
      },
      name: 'store',
      meta: {
        title: '门店列表',
        icon: ''
      }
    }, {
      path: 'activate',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/activate/index');
      },
      name: 'activate',
      meta: {
        title: '启动列表',
        icon: ''
      }
    }, {
      path: 'assistant',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/assistant/index');
      },
      name: 'assistant',
      meta: {
        title: '启动列表',
        icon: ''
      }
    }, {
      path: 'frequency',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/frequency/index');
      },
      name: 'frequency',
      meta: {
        title: '共享仓次数列表',
        icon: ''
      }
    }, {
      path: 'recharge',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/recharge/index');
      },
      name: 'recharge',
      meta: {
        title: '共享仓充值订单列表',
        icon: ''
      }
    }, {
      path: 'equipment',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/equipment/index');
      },
      name: 'equipment',
      meta: {
        title: '设备列表',
        icon: ''
      }
    }, {
      path: 'storekeeper',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/storekeeper/index');
      },
      name: 'storekeeper',
      meta: {
        title: '舱主店主列表',
        icon: ''
      }
    }, {
      path: 'signed',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/signed/index');
      },
      name: 'signed',
      meta: {
        title: '签约列表',
        icon: ''
      }
    }, {
      path: 'business',
      component: function component() {
        return import('@/views/user/Jwebmalladmin/business/index');
      },
      name: 'business',
      meta: {
        title: '商用舱列表',
        icon: ''
      }
    }]
  }, {
    path: 'lookcapaxs',
    component: function component() {
      return import('@/views/user/lookcapaxs/index');
    },
    name: 'lookcapaxs',
    meta: {
      title: '升星查看  ',
      icon: ''
    }
  }, {
    path: 'whole',
    component: function component() {
      return import('@/views/user/whole/index');
    },
    name: 'whole',
    meta: {
      title: '批发平台关联',
      icon: ''
    }
  }, {
    path: 'fillscore',
    component: function component() {
      return import('@/views/user/fillscore/index');
    },
    name: 'fillscore',
    meta: {
      title: '用户补缴',
      icon: ''
    }
  }, {
    path: 'inventory',
    component: function component() {
      return import('@/views/user/inventory/index');
    },
    name: 'inventory',
    meta: {
      title: '库存管理',
      icon: ''
    }
  }, {
    path: 'inventorystock',
    component: function component() {
      return import('@/views/user/inventorystock/index');
    },
    name: 'inventorystock',
    meta: {
      title: '库存明细',
      icon: ''
    }
  }, {
    path: 'agentCapaorder',
    name: 'agentCapaorder',
    meta: {
      title: '用户等级'
    },
    component: function component() {
      return import('@/views/user/capa/agentCapaorder/index');
    }
  }, {
    path: 'give',
    component: function component() {
      return import('@/views/user/give/index');
    },
    name: 'give',
    meta: {
      title: '库存管理',
      icon: ''
    }
  }, {
    path: 'detection',
    component: function component() {
      return import('@/views/user/detection/index');
    },
    name: 'detection',
    meta: {
      title: '检测记录',
      icon: ''
    }
  }]
};
export default userRouter;